export enum AdminDocumentType {
  POLICY_COMBINED = 'policy-combined',
  HIPAA_COMPLETED = 'hipaa-completed',
  RELEASE_TRANSFER_AUTHORIZATION = 'release-transfer-authorization',
}
